module.exports = __webpack_public_path__ + "img/contact.9da3d703.jpg";